/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssignStudentsToMeetDay } from '../../models/assign-students-to-meet-day';

export interface AssignMeetDayStudent$Params {
  meetDayId: string;
      body?: AssignStudentsToMeetDay
}

export function assignMeetDayStudent(http: HttpClient, rootUrl: string, params: AssignMeetDayStudent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, assignMeetDayStudent.PATH, 'post');
  if (params) {
    rb.path('meetDayId', params.meetDayId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

assignMeetDayStudent.PATH = '/meetday/{meetDayId}/student/assign';
